import AddToPhotosIcon from '@mui/icons-material/AddToPhotos';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import SaveIcon from '@mui/icons-material/Save';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { useRouter } from 'next/router';
import React from 'react';
interface IButton {
  handleClick(): void;
}

export const SaveButton = ({ handleClick }: any) => {
  const { locale } = useRouter();
  return (
    <Box>
      <Button
        variant="contained"
        onClick={handleClick}
        startIcon={<SaveIcon />}
      >
        {locale === 'fr' ? 'Enregistrer' : 'Save'}
      </Button>
    </Box>
  );
};

export const AddButton = ({ handleClick }: IButton) => {
  const { locale } = useRouter();
  return (
    <Box>
      <Tooltip
        title={
          locale === 'fr'
            ? 'Cliquez si vous avez un autre projet à ajouter'
            : 'Click if you have an other project to add'
        }
        arrow
      >
        <Button
          variant="outlined"
          color="secondary"
          onClick={handleClick}
          startIcon={<AddToPhotosIcon />}
        >
          {locale === 'fr' ? 'Ajouter' : 'Add'}
        </Button>
      </Tooltip>
    </Box>
  );
};

export const DeleteButton = ({ handleClick }: IButton) => {
  const { locale } = useRouter();
  return (
    <Box sx={{ mb: '-10px' }}>
      <Tooltip title={locale === 'fr' ? 'Supprimer' : 'Delete'} arrow>
        <IconButton sx={{ float: 'right' }} onClick={handleClick}>
          <RemoveCircleIcon color="error" />
        </IconButton>
      </Tooltip>
    </Box>
  );
};
